import {Dispatch, useCallback, useState} from "react";

type PatchStateAction<S> = Partial<S> | ((prevState: S) => Partial<S>);

export function usePatchState<S>(initialState: S | (() => S)): [S, Dispatch<PatchStateAction<S>>] {
    const [state, setState] = useState<S>(initialState)

    const patchState = useCallback<Dispatch<PatchStateAction<S>>>((arg: PatchStateAction<S>) => {
        setState((prevState: S) => {
            if (typeof arg === 'function') {
                return {
                    ...prevState,
                    ...arg(prevState),
                }
            } else {
                return {
                    ...prevState,
                    ...arg,
                }
            }
        })
    }, [setState])

    return [state, patchState]
}
